"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _SliderHandle = _interopRequireDefault(require("./SliderHandle"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Slider = ({
  defaultValue,
  dotColor,
  dotBorderColor,
  handleBarColor,
  handleColor,
  handleSize,
  included,
  max,
  markColor,
  marks,
  min,
  onAfterChange,
  onChange,
  railColor,
  step,
  ...otherProps
}) => {
  const [value, setValue] = (0, _react.useState)(defaultValue < min ? min : defaultValue > max ? max : defaultValue);
  const getNearestStepValue = (0, _react.useCallback)(() => {
    const nearestUpperValue = Math.ceil(value / step) * step;
    const nearestLowerValue = Math.floor(value / step) * step;
    const diffToUpperValue = nearestUpperValue - value;
    const diffToLowerValue = value - nearestLowerValue;

    if (diffToUpperValue > diffToLowerValue) {
      return nearestLowerValue;
    }

    return nearestUpperValue;
  }, [step, value]);
  const onAfterSliderChange = (0, _react.useCallback)(value => {
    // snap the slider to the nearest value after it is released
    const newValue = getNearestStepValue(value);
    setValue(newValue);

    if (typeof onAfterChange === 'function') {
      onAfterChange(newValue);
    }
  }, [onAfterChange, setValue, getNearestStepValue]);
  const onSliderChange = (0, _react.useCallback)(value => {
    // set the value to the value of the step
    setValue(value);

    if (typeof onChange === 'function') {
      onChange(getNearestStepValue(value));
    }
  }, [onChange, getNearestStepValue]);
  const stepValue = (max - min) / 200;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledSlider, {
    "aria-label": "Slider",
    defaultValue: defaultValue,
    dotColor: dotColor,
    handle: props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_SliderHandle.default, {
      role: "slider",
      handleSize: handleSize,
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": value,
      handleBarColor: handleBarColor,
      handleColor: handleColor,
      ...props
    }),
    handleSize: handleSize,
    dotBorderColor: dotBorderColor,
    included: included,
    markColor: markColor,
    marks: marks,
    max: max,
    min: min,
    onChange: onSliderChange,
    onAfterChange: onAfterSliderChange,
    railColor: railColor,
    step: stepValue,
    value: value,
    ...otherProps
  });
};

Slider.propTypes = {
  defaultValue: _propTypes.default.number,
  dotColor: _propTypes.default.string,
  dotBorderColor: _propTypes.default.string,
  handleBarColor: _propTypes.default.string,
  handleColor: _propTypes.default.string,
  handleSize: _propTypes.default.string,
  included: _propTypes.default.bool,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  markColor: _propTypes.default.string,
  marks: _propTypes.default.object,
  railColor: _propTypes.default.string
};
Slider.defaultProps = {
  defaultValue: 0,
  included: false,
  dotBorderColor: undefined,
  dotColor: undefined,
  handleColor: undefined,
  handleBarColor: undefined,
  markColor: undefined,
  railColor: undefined,
  handleSize: _theme.default.space[7],
  marks: {
    '0': 0,
    '20': 20,
    '40': 40,
    '60': 60,
    '80': 80,
    '100': 100
  },
  max: 100,
  min: 0,
  step: 1
};
var _default = Slider;
exports.default = _default;